exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unbind-box[data-v-7f16641b] {\n  height: 600px;\n}\n.unbind-box > div[data-v-7f16641b] {\n    margin-top: 220px;\n}\n.unbind-box > div > p[data-v-7f16641b] {\n      margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7f16641b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/root/workspace/platform-admin_Cbe5/src/style/theme.scss","/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/empty/unbind.vue
// module id = 904
// module chunks = 30